import SolutionAlertRules from './SolutionAlertRules';

export default SolutionAlertRules;
